import formclasses from "../../Employee/AddEmployeeDirectory/AddEmployeeDirectory.module.css";
import classes from "../AddNewCompany/AddNewCompany.module.css";
import editClasses from "./EditNewCompany.module.css";
import React, { useContext, useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { useFormik } from "formik";
import * as Yup from "yup";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import { toast } from "react-toastify";
import ReactFileReader from "react-file-reader";
import authContext from "../../../../AuthContext/authContext";
import Modal from 'react-modal';
import ManagersTable from '../ManagersTable/ManagersTable';
import { useNavigate } from 'react-router-dom';

// Make sure to bind modal to your appElement (http://reactcommunity.org/react-modal/accessibility/)
Modal.setAppElement('#root');
const base_url = process.env.REACT_APP_BASE_URL;
const EditNewCompany = ({ initialData, onSuccess }) => {
  const [startDate, setStartDate] = useState(
    new Date(initialData.subscriptionStartDate.slice(0, 10))
  );
  const [endDate, setEndDate] = useState(
    new Date(initialData.subscriptionEndDate.slice(0, 10))
  );
  console.log(initialData, "initialData");
  const [preview, setPreview] = useState(initialData.logo);
  const [showPPOModal, setShowPPOModal] = useState(false);
  const [ppoData, setPpoData] = useState(initialData.ppoData || []);
  const navigate = useNavigate();

  // Get latest PPO entry for the form (sorted by createdAt in descending order)
  const sortedPpoData = [...(initialData.ppoData || [])].filter((item) => item.isActive);
  console.log(sortedPpoData, "sortedPpoData");

  // Get the latest PPO entry or use defaults
  const latestPpo = sortedPpoData.length > 0 ? {
    ppoNote: sortedPpoData[0].ppoNote || "",
    ppoPassCount: sortedPpoData[0].ppoPassCount || 0,
    availablePassCount: sortedPpoData[0].availablePassCount || 0,
    ppomodel: sortedPpoData[0].ppomodel || false,
    isActive: sortedPpoData[0].isActive || false,
    createdAt: sortedPpoData[0].createdAt || ""
  } : {
    ppoNote: "",
    ppoPassCount: 0,
    availablePassCount: 0,
    ppomodel: false,
    isActive: false,
    createdAt: ""
  };

  // useEffect(() => {
  //   console.log('Latest PPO:', latestPpo);
  // }, []);

  // Previous PPO entries for the table (all except the latest one)
  const previousPpoEntries = sortedPpoData.length > 1 ? sortedPpoData.slice(1) : [];
  const [managers, setManagers] = useState(
    initialData.managers && initialData.managers.length > 0
      ? initialData.managers.filter(manager => manager.user_type === "Company Manager").map((manager, index) => ({
        id: manager._id || `new-${index}`,
        name: manager.name || "",
        email: manager.email || "",
        phone: manager.phone || "",
        user_type: manager.user_type === "location" ? `Location ${manager.location}` : manager.user_type || "",
        password: "",
        _id: manager._id,
        deletable: manager.user_type === "location" && !manager.location_id ? false : true,
        location: manager.location || "",
        isEditing: false
      }))
      : []
  );

  const ctx = useContext(authContext);
  const token = ctx.token;
  const [loading, setLoading] = useState(false);
  const [loadingQR, setLoadingQR] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [managerToDelete, setManagerToDelete] = useState(null);
  const [companyManagers, _] = useState(initialData.managers.filter(manager => manager.user_type === "Company Manager"));
  console.log(companyManagers, "companyManagers");
  const phoneRegExp =
    /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
  const nameRegExp = /^[A-Za-z ]+$/;




  const handleDeleteConfirm = async () => {
    if (managerToDelete === null) return;

    const { index, manager } = managerToDelete;
    const newManagers = [...managers];
    newManagers.splice(index, 1);

    // Check if manager exists in initial data (has an _id)
    if (manager._id) {
      try {
        const deleteReqObj = {
          method: "DELETE",
          url: `${base_url}/user/locationManager/${manager._id}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${ctx.token}`,
          },
        };

        await axios(deleteReqObj);
        setManagers(newManagers); // Only update state after successful API call
        toast.success("Manager deleted successfully");
      } catch (err) {
        console.log(err);
        toast.error(err.response?.data?.error?.message || "Failed to delete manager");
      }
    } else {
      // For new managers not yet saved to the server, just update the state
      setManagers(newManagers);
    }

    // Reset the modal state
    setShowDeleteModal(false);
    setManagerToDelete(null);
  };



  const handleDeleteCancel = () => {
    setShowDeleteModal(false);
    setManagerToDelete(null);
  };

  const handleManagerChange = (index, field, value) => {
    const updatedManagers = [...managers];
    updatedManagers[index] = {
      ...updatedManagers[index],
      [field]: value
    };
    setManagers(updatedManagers);
  };

  

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      company_name: initialData.name || "",
      managers: managers.length > 0 ? managers : [{ name: "", email: "", phone: "", password: "", _id: "" }],
      storage_duration: initialData.storageDuration || "",
      start_date: startDate,
      end_date: endDate,
      allowed_location: initialData.noOfLocation || 1,
      location_switch: initialData.location,
      visitor_verification: initialData.visitorVerification,
      geoLocation_switch: initialData.geoLocation || false,
      valid_id: initialData.validId || false,
      prebooking_switch: initialData.prebookingSwitch || false,
      accessory_check: initialData.accessoryCheck || false,
      card_check: initialData.cardCheck || false,
      delagate_check: initialData.delagateCheck || false,
      vendor_check: initialData.vendorCheck || false,
      guard_check: initialData.guardCheck || false,
      boombarier_qr_check: initialData.boombarierQrCheck || false,
      endMeetingNotification: initialData.endMeetingNotification || false,
      employeeApprovalMailCheck: initialData.employeeApprovalMailCheck || false,
      Bgcolor: initialData.backgroundColor,
      footer_switch: initialData.footerStatus,
      footer_line_1: initialData.footerStatus ? initialData.footerTextOne : "",
      footer_line_2: initialData.footerStatus ? initialData.footerTextTwo : "",
      directory_switch: initialData.employeeDirectory,
      logo: undefined,
      que1: initialData.covidQuestionOne || "",
      ans1: initialData.covidAnswerOne || "",
      que2: initialData.covidQuestionTwo || "",
      ans2: initialData.covidAnswerTwo || "",
      que3: initialData.covidQuestionThree || "",
      ans3: initialData.covidAnswerThree || "",
      que4: initialData.covidQuestionFour || "",
      ans4: initialData.covidAnswerFour || "",
      que5: initialData.covidQuestionFive || "",
      ans5: initialData.covidAnswerFive || "",
      standy: initialData.standy || "",
      showRemark: initialData.showRemark || false,
      ppo_enabled: latestPpo.ppomodel || false,
      ppo_notes: latestPpo.ppoNote || "",
      ppo_pass_count: latestPpo.availablePassCount > 0 ? latestPpo.availablePassCount : (latestPpo.ppoPassCount || 0),
      ppo_expiry_date: latestPpo.expiryDate
        ? new Date(latestPpo.expiryDate).toISOString().split('T')[0]
        : (latestPpo.createdAt ? new Date(latestPpo.createdAt).toISOString().split('T')[0] : ""),
    },
    validationSchema: Yup.object({
      company_name: Yup.string().required("Please enter your name"),
      managers: Yup.array().of(
        Yup.object().shape({
          name: Yup.string()
            .matches(nameRegExp, "Please enter valid name")
            .required("Please enter manager name"),
          email: Yup.string()
            .email("Invalid email address")
            .required("Please enter manager email address"),
          phone: Yup.string()
            .matches(phoneRegExp, "Phone number is not valid")
            .length(10, "Phone number should be of 10 digits")
            .required("Please enter manager phone no."),
          password: Yup.string()
            .when('_id', {
              is: (id) => !id, // Only validate password if _id doesn't exist (new manager)
              then: (schema) => schema
                .min(8, "Password must be at least 8 characters long")
                .required("Password is required for new managers"),
              otherwise: (schema) => schema.notRequired()
            })
        })
      ),
      storage_duration: Yup.string().required(
        "Please enter data storage duration"
      ),
      start_date: Yup.string().required("Please enter start date"),
      end_date: Yup.string().required("Please enter end date"),
      logo: Yup.mixed(),
      que1: Yup.string(),
      ans1: Yup.string(),
      que2: Yup.string(),
      ans2: Yup.string(),
      que3: Yup.string(),
      ans3: Yup.string(),
      que4: Yup.string(),
      ans4: Yup.string(),
      que5: Yup.string(),
      ans5: Yup.string(),
      location_switch: Yup.boolean(),
      footer_switch: Yup.boolean(),
      geoLocation_switch: Yup.boolean(),
      valid_id: Yup.boolean(),
      accessory_check: Yup.boolean(),
      card_check: Yup.boolean(),
      delagate_check: Yup.boolean(),
      vendor_check: Yup.boolean(),
      guard_check: Yup.boolean(),
      endMeetingNotification: Yup.boolean(),
      employeeApprovalMailCheck: Yup.boolean()
    }),
    onSubmit: async (values) => {
      console.log(values, "values");
      setLoading(true);
      const formData = new FormData();
      formData.append("id", initialData._id);
      formData.append("name", values.company_name);
      formData.append("type", "Company");

      // Add managers data
      formData.append("managers", JSON.stringify(managers.map(manager => ({
        name: manager.name,
        email: manager.email,
        phone: manager.phone,
        password: manager.password || "",
        _id: manager._id,
      }))));
      if (managers.length > 0) {
        formData.append("managerName", managers[0].name);
        formData.append("managerEmail", managers[0].email);
        formData.append("managerPhone", managers[0].phone);
        formData.append("password", managers[0].password); // Using phone as default password
      }
      formData.append("userType", "Company Manager");
      formData.append("storageDuration", values.storage_duration);
      formData.append(
        "subscriptionStartDate",
        values.start_date.toISOString().slice(0, 10)
      );
      formData.append(
        "subscriptionEndDate",
        values.end_date.toISOString().slice(0, 10)
      );
      formData.append("location", values.location_switch);
      formData.append("prebookingSwitch", values.prebooking_switch);
      formData.append("noOfLocation", values.allowed_location);
      formData.append("visitorVerification", values.visitor_verification);
      formData.append("backgroundColor", values.Bgcolor);
      if (values.logo) {
        formData.append("logoFile", values.logo);
      }
      formData.append("footerStatus", values.footer_switch);
      if (values.footer_switch) {
        formData.append("footerTextOne", values.footer_line_1);
        formData.append("footerTextTwo", values.footer_line_2);
      }
      formData.append("employeeDirectory", values.directory_switch);
      formData.append("geoLocation", values.geoLocation_switch);
      formData.append("validId", values.valid_id);
      formData.append("accessoryCheck", values.accessory_check);
      formData.append("cardCheck", values.card_check);
      formData.append("delagateCheck", values.delagate_check);
      formData.append("vendorCheck", values.vendor_check);
      formData.append("guardCheck", values.guard_check);
      formData.append("boombarierQrCheck", values.boombarier_qr_check);
      formData.append("endMeetingNotification", values.endMeetingNotification);
      formData.append("showRemark", values.showRemark);
      formData.append(
        "employeeApprovalMailCheck",
        values.employeeApprovalMailCheck
      );

      if (values.que1 !== "") {
        formData.append("covidQuestionOne", values.que1);
        formData.append("covidAnswerOne", values.ans1);
      }
      if (values.que2 !== "") {
        formData.append("covidQuestionTwo", values.que2);
        formData.append("covidAnswerTwo", values.ans2);
      }
      if (values.que3 !== "") {
        formData.append("covidQuestionThree", values.que3);
        formData.append("covidAnswerThree", values.ans3);
      }
      if (values.que4 !== "") {
        formData.append("covidQuestionFour", values.que4);
        formData.append("covidAnswerFour", values.ans4);
      }
      if (values.que5 !== "") {
        formData.append("covidQuestionFive", values.que5);
        formData.append("covidAnswerFive", values.ans5);
      }

      // Check if PPO data has been modified
      const isPpoModified =
        values.ppo_enabled !== (latestPpo.ppomodel || false) ||
        values.ppo_notes !== (latestPpo.ppoNote || '') ||
        values.ppo_pass_count !== (latestPpo.availablePassCount || 0) ||
        (values.ppo_expiry_date && new Date(values.ppo_expiry_date).toISOString() !== latestPpo.expiryDate);

      console.log('PPO Modified:', isPpoModified);
      console.log('Current values:', {
        enabled: values.ppo_enabled,
        notes: values.ppo_notes,
        passCount: values.ppo_pass_count,
        expiryDate: values.ppo_expiry_date
      });
      console.log('Latest PPO:', latestPpo);

      // Only include PPO data if it has been modified and PPO is enabled or was previously enabled
      if (isPpoModified && (values.ppo_enabled || latestPpo.ppomodel)) {
        if (values.ppo_enabled) {
          // Create only the latest PPO entry
          const latestPpoEntry = {
            ppoNote: values.ppo_notes,
            ppoPassCount: values.ppo_pass_count,
            availablePassCount: values.ppo_pass_count,
            ppomodel: true,
            isActive: true,
            companyId: initialData._id,
            expiryDate: values.ppo_expiry_date ? new Date(values.ppo_expiry_date).toISOString() : null,
            createdAt: new Date().toISOString(),
            updatedAt: new Date().toISOString(),
            _id: `temp_${Date.now()}`,
            __v: 0
          };

          console.log('New PPO Entry:', latestPpoEntry);

          // Only send the latest PPO entry
          formData.append("ppoData", JSON.stringify([latestPpoEntry]));
        } else {
          // If PPO is being disabled, send an empty array
          // Only send disable update if there was a previous PPO entry
          if (latestPpo._id) {
            formData.append("ppoData", JSON.stringify([{
              ...latestPpo,
              ppomodel: false,
              isActive: false,
              updatedAt: new Date().toISOString()
            }]));
            console.log('Disabled PPO:', { ...latestPpo, ppomodel: false });
          }
        }
      }
      if (companyManagers.length > 2) {
        toast.warning("Maximum of 2 managers allowed per company");
        setLoading(false);
        return;
      }
      axios
        .put(`${base_url}/company/update`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`
          }
        })
        .then((res) => {
          
          toast.success("Company Updated Successfully!!");
          setLoading(false);
          onSuccess();
          navigate('/companies');
        })
        .catch((err) => {
          console.log(err, "err");
          toast.error(
            err.response.data.error.message || "Failed to update company"
          );
          setLoading(false);
        });
    }
  });

  const handleFile = (file) => {
    setPreview(file.base64);
    formik.setFieldValue("logo", file.fileList[0]);
  };

  function downloadImage(dataURL) {
    var link = document.createElement("a");
    link.download = "company-qr.png";
    link.href = dataURL;
    link.click();
  }

  const donwloadQrCode = (url) => {
    downloadImage(url);
  };

  const generateQrCode = () => {
    setLoadingQR(true);
    axios
      .post(
        `${base_url}/company/generate-qr-code`,
        {
          companyId: initialData._id
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          }
        }
      )
      .then((res) => {
        toast.dismiss();
        toast.success("Qr code generated Successfully!!");
        setLoadingQR(false);
        setTimeout(() => {
          formik.setFieldValue("standy", res.data.standyUrl);
        }, 0);
      })
      .catch((err) => {
        console.log(err);
        toast.dismiss();
        toast.error(
          err.response.data.error.message || "Failed to generate Qr code"
        );
        setLoadingQR(false);
      });
  };

  // Update formik values when managers change
  // useEffect(() => {
  //   formik.setFieldValue('managers', managers);
  // }, [managers]);

  return (
    <>
      <div className={classes.mainCont}>

        <div className={`${formclasses.mainCont} ${classes.Container}`}>
          <h3>Edit New Company</h3>

          <form className={classes.FormDiv} onSubmit={formik.handleSubmit}>
            <div className={editClasses.editDiv}>
              <div style={{ width: "60%" }}>
                <div className={`${formclasses.formGrp}`}>
                  <label for="company_name">Company Name:</label>
                  <div>
                    <input
                      type="text"
                      id="company_name"
                      name="company_name"
                      {...formik.getFieldProps("company_name")}
                    />
                    <span className={formclasses.profileerrMsg}>
                      {formik.touched.company_name &&
                        formik.errors.company_name ? (
                        <div>{formik.errors.company_name}</div>
                      ) : null}
                    </span>
                  </div>
                </div>
                <ManagersTable
                  managers={managers}
                  setManagers={setManagers}
                  formik={formik}
                  id={initialData._id}
                  handleManagerChange={handleManagerChange}
                  token={token}
                  base_url={base_url}
                />

                <div className={formclasses.formGrp}>
                  <label for="storage_duration">Data Duration Storage:</label>
                  <div>
                    <select
                      id="storage_duration"
                      name="storage_duration"
                      className={classes.dropDown}
                      {...formik.getFieldProps("storage_duration")}
                      placeholder="Select"
                    >
                      <option value="" disabled selected>
                        Select your option
                      </option>
                      <option value="1 Month">1 Month</option>
                      <option value="3 Month">3 Month</option>
                      <option value="6 Month">6 Month</option>
                      <option value="9 Month">9 Month</option>
                      <option value="12 Month">12 Month</option>
                    </select>
                    <span className={formclasses.profileerrMsg}>
                      {formik.touched.storage_duration &&
                        formik.errors.storage_duration ? (
                        <div>{formik.errors.storage_duration}</div>
                      ) : null}
                    </span>
                  </div>

                  {/* <input type="text" id="lname" name="lname" /> */}
                </div>
                <div
                  className={`${classes.formGrp}`}
                  style={{ display: "flex", margin: "0.8rem 0 0.8rem 0" }}
                >
                  <label for="subscription">Subscription:</label>
                  <span>
                    <span className={classes.dateDiv}>
                      <DatePicker
                        id="start_date"
                        name="start_date"
                        showYearDropdown
                        minDate={new Date()}
                        placeholderText="Start Date"
                        selected={startDate}
                        onChange={(date) => {
                          setStartDate(date);
                          formik.setFieldValue("start_date", date);
                        }}
                        onBlur={formik.handleBlur}
                        value={startDate}
                        className={classes.customDate}
                      />
                      <div
                        style={{
                          width: "10%",
                          height: "0px",
                          backgroundColor: "black",
                          border: "1px solid black",
                          margin: "0 12px 0 0px"
                        }}
                      ></div>

                      <DatePicker
                        id="end_date"
                        name="end_date"
                        showYearDropdown
                        placeholderText="End Date"
                        selected={endDate}
                        // minDate={new Date(formik.values.start_date + 1)}
                        minDate={new Date().setDate(new Date().getDate() + 1)}
                        onChange={(date) => {
                          setEndDate(date);
                          formik.setFieldValue("end_date", date);
                        }}
                        onBlur={formik.handleBlur}
                        value={startDate}
                        className={classes.customDate}
                      />
                    </span>
                    <span
                      className={formclasses.profileerrMsg}
                      style={{ marginLeft: "1.5rem", color: "rgb(223, 58, 58)" }}
                    >
                      {(formik.touched.start_date && formik.errors.start_date) ||
                        (formik.touched.end_date && formik.errors.end_date) ? (
                        <div>
                          {formik.errors.start_date || formik.errors.end_date}
                        </div>
                      ) : null}
                    </span>
                  </span>
                </div>
                <div className={classes.locationDiv}>
                  <div className={classes.allowedLocation}>
                    <div className="d-flex align-items-center">
                      <label for="allowed_location">Allowed Location</label>
                      <input
                        className="form-control form-control-location"
                        type="number"
                        id="allowed_location"
                        name="allowed_location"
                        {...formik.getFieldProps("allowed_location")}
                        disabled={!formik.values.location_switch}
                      />
                    </div>
                    {/* <select
                    id="allowed_location"
                    name="allowed_location"
                    {...formik.getFieldProps("allowed_location")}
                    disabled={!formik.values.location_switch}
                  >
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                  </select> */}
                  </div>

                  <div className={classes.toggleDiv}>
                    <div className="form-check form-switch">
                      <label className="form-check-label" for="location_switch">
                        Location
                      </label>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="location_switch"
                        name="location_switch"
                        defaultChecked={formik.values.location_switch}
                        {...formik.getFieldProps("location_switch")}
                      />
                    </div>
                  </div>
                </div>
                <div className={classes.toggleSwitch}>
                  <div className="form-check form-switch">
                    <label
                      className="form-check-label"
                      for="visitor_verification"
                    >
                      Visitor Verification
                    </label>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="visitor_verification"
                      name="visitor_verification"
                      defaultChecked={formik.values.visitor_verification}
                      {...formik.getFieldProps("visitor_verification")}
                    />
                  </div>
                </div>
                <div className={classes.colorDiv}>
                  <div className={classes.pickerCont}>
                    <label for="Bgcolor">Background Color</label>
                    <div className={classes.picker}>
                      <input
                        type="color"
                        id="Bgcolor"
                        name="Bgcolor"
                        // value="#ff0000"
                        // defaultValue="#ffffff"
                        {...formik.getFieldProps("Bgcolor")}
                      />
                      <img
                        src={require("../../../../assets/img/admin-images/downIcon.png")}
                      />
                    </div>
                  </div>

                  {/* <ReactFileReader
                  name="logo"
                  fileTypes={[".png", ".jpg", ".jpeg"]}
                  handleFiles={handleFile}
                  handleBlur={formik.handleBlur}
                  base64={true}
                > */}
                  <div className={classes.logoDiv}>
                    <label for="logo">Logo</label>

                    <ReactFileReader
                      name="logo"
                      fileTypes={[".png", ".jpg", ".jpeg"]}
                      handleFiles={handleFile}
                      handleBlur={formik.handleBlur}
                      base64={true}
                    >
                      <div className={`${classes.uploadBtnWrapper}`}>
                        <button type="button" className={`${classes.btn}`}>
                          <img
                            src={require("../../../../assets/img/admin-images/upload.png")}
                          />
                          <div>Select</div>
                        </button>
                        {/* <input type="file" name="myfile" /> */}
                      </div>
                    </ReactFileReader>

                    <div className={classes.previewLogo}>
                      {(preview || initialData.logo) && (
                        <img src={preview || initialData.logo} />
                      )}
                    </div>

                    <div style={{ display: "block", color: "rgb(223, 58, 58)" }}>
                      {formik.touched.logo && formik.errors.logo ? (
                        <div>{formik.errors.logo}</div>
                      ) : null}
                    </div>
                  </div>
                  {/* </ReactFileReader> */}
                  {/* <div className={classes.previewLogo}>
                  {(preview || initialData.logo) && (
                    <img src={preview || initialData.logo} />
                  )}
                </div> */}
                </div>
                <div className={classes.toggleSwitch}>
                  <div className="form-check form-switch">
                    <label className="form-check-label" for="footer_switch">
                      Footer
                    </label>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="footer_switch"
                      name="footer_switch"
                      defaultChecked={formik.values.footer_switch}
                      {...formik.getFieldProps("footer_switch")}
                    />
                  </div>
                </div>
                <div className={classes.toggleSwitch}>
           
          </div>
                {formik.values.footer_switch && (
                  <>
                    <input
                      className={classes.footerInpDiv}
                      placeholder="Powered by Fedicoms Pvt Ltd."
                      id="footer_line_1"
                      name="footer_line_1"
                      {...formik.getFieldProps("footer_line_1")}
                    />{" "}
                    <br />
                    <input
                      className={classes.footerInpDiv}
                      placeholder="info@fedicoms.com"
                      id="footer_line_2"
                      name="footer_line_2"
                      {...formik.getFieldProps("footer_line_2")}
                    />
                  </>
                )}
                <div className={classes.toggleSwitch}>
                  <div className="form-check form-switch">
                    <label className="form-check-label" for="directory_switch">
                      Employee Directory
                    </label>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      // id="flexSwitchCheckChecked"
                      id="directory_switch"
                      name="directory_switch"
                      defaultChecked={formik.values.directory_switch}
                      {...formik.getFieldProps("directory_switch")}
                    />
                  </div>
                </div>
                <div className={classes.toggleSwitch}>
                  <div className="form-check form-switch">
                    <label className="form-check-label" for="geoLocation_switch">
                      Geo Location
                    </label>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      // id="flexSwitchCheckChecked"
                      id="geoLocation_switch"
                      name="geoLocation_switch"
                      defaultChecked={formik.values.geoLocation_switch}
                      {...formik.getFieldProps("geoLocation_switch")}
                    />
                  </div>
                </div>
                
                <div className={classes.toggleSwitch}>
                  <div className="form-check form-switch">
                    <label className="form-check-label" for="valid_id">
                      Valid Id
                    </label>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      // id="flexSwitchCheckChecked"
                      id="valid_id"
                      name="valid_id"
                      defaultChecked={formik.values.valid_id}
                      {...formik.getFieldProps("valid_id")}
                    />
                  </div>
                </div>

                <div className={classes.toggleSwitch}>
            <div className="form-check form-switch">
              <label className="form-check-label" for="prebooking_switch">
                Enable Appointment
              </label>
              <input
                className="form-check-input"
                type="checkbox"
                id="prebooking_switch"
                name="prebooking_switch"
                defaultChecked={formik.values.prebooking_switch}
                {...formik.getFieldProps("prebooking_switch")}
              />
            </div>
          </div>
                <div className={classes.toggleSwitch}>
                  <div className="form-check form-switch">
                    <label className="form-check-label" for="accessory_check">
                      Accessory
                    </label>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      // id="flexSwitchCheckChecked"
                      id="accessory_check"
                      name="accessory_check"
                      defaultChecked={formik.values.accessory_check}
                      {...formik.getFieldProps("accessory_check")}
                    />
                  </div>
                </div>
                <div className={classes.toggleSwitch}>
                  <div className="form-check form-switch">
                    <label className="form-check-label" for="card_check">
                      Card No
                    </label>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      // id="flexSwitchCheckChecked"
                      id="card_check"
                      name="card_check"
                      defaultChecked={formik.values.card_check}
                      {...formik.getFieldProps("card_check")}
                    />
                  </div>
                </div>
                <div className={classes.toggleSwitch}>
                  <div className="form-check form-switch">
                    <label className="form-check-label" for="delagate_check">
                      Delagate Pass
                    </label>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      // id="flexSwitchCheckChecked"
                      id="delagate_check"
                      name="delagate_check"
                      defaultChecked={formik.values.delagate_check}
                      {...formik.getFieldProps("delagate_check")}
                    />
                  </div>
                </div>
                <div className={classes.toggleSwitch}>
                  <div className="form-check form-switch">
                    <label className="form-check-label" for="vendor_check">
                      Vendor Pass
                    </label>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="vendor_check"
                      name="vendor_check"
                      defaultChecked={formik.values.vendor_check}
                      {...formik.getFieldProps("vendor_check")}
                    />
                  </div>
                </div>
                <div className={classes.toggleSwitch}>
                  <div className="form-check form-switch">
                    <label className="form-check-label" for="guard_check">
                      Guard
                    </label>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="guard_check"
                      name="guard_check"
                      defaultChecked={formik.values.guard_check}
                      {...formik.getFieldProps("guard_check")}
                    />
                  </div>
                </div>
                <div className={classes.toggleSwitch}>
                  <div className="form-check form-switch">
                    <label className="form-check-label" for="boombarier_qr_check">
                    Boom Barrier QR Code
                    </label>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="boombarier_qr_check"
                      name="boombarier_qr_check"
                      defaultChecked={formik.values.boombarier_qr_check}
                      {...formik.getFieldProps("boombarier_qr_check")}
                    />
                  </div>
                </div>
                <div className={classes.toggleSwitch}>
                  <div className="form-check form-switch">
                    <label
                      className="form-check-label"
                      for="employeeApprovalMailCheck"
                    >
                      Employee Approval Mail
                    </label>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="employeeApprovalMailCheck"
                      name="employeeApprovalMailCheck"
                      defaultChecked={formik.values.employeeApprovalMailCheck}
                      {...formik.getFieldProps("employeeApprovalMailCheck")}
                    />
                  </div>
                </div>

                {/* PPO Toggle */}
                <div className={classes.toggleSwitch}>
                  <div className="form-check form-switch">
                    <label className="form-check-label" htmlFor="ppo_enabled">
                      Enable PPU
                    </label>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="ppo_enabled"
                      name="ppo_enabled"
                      checked={formik.values.ppo_enabled}
                      onChange={async (e) => {
                        const newValue = e.target.checked;
                        formik.setFieldValue('ppo_enabled', newValue);

                        if (!newValue) {
                          // Call API to disable PPO
                          try {
                            await axios({
                              method: 'PUT',
                              url: `${base_url}/company/unsubscribe-ppo/${initialData._id}`,
                              headers: {
                                'Authorization': `Bearer ${token}`,
                                'Content-Type': 'application/json'
                              }
                            });
                            toast.success("PPU disabled successfully");
                          } catch (error) {
                            console.error('Failed to disable PPU:', error);
                            // Revert the toggle if API call fails
                            formik.setFieldValue('ppo_enabled', true);
                            toast.error("Failed to disable PPU");
                          }
                        } else {
                          // Navigate to add PPO configuration page
                          navigate(`/company/${initialData._id}/add-ppo-configuration`, {
                            state: {
                              companyName: initialData.name,
                            },
                          });
                        }
                      }}
                    />
                    {formik.values.ppo_enabled && (

                      <button
                        type="button"
                        className="btn btn-sm btn-link p-0 ms-2"
                        onClick={() => navigate(`/company/${initialData._id}/ppo-configuration`, {
                          state: {
                            companyName: initialData.name,
                          },
                        })}
                      >
                        Configure PPU
                      </button>
                    )}
                  </div>
                </div>
                <div className={classes.toggleSwitch}>
                  <div className="form-check form-switch">
                    <label
                      className="form-check-label"
                      for="endMeetingNotification"
                    >
                      End Meeting Notification
                    </label>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      // id="flexSwitchCheckChecked"
                      id="endMeetingNotification"
                      name="endMeetingNotification"
                      defaultChecked={formik.values.endMeetingNotification}
                      {...formik.getFieldProps("endMeetingNotification")}
                    />
                  </div>
                </div>
                <div className={classes.toggleSwitch}>
                  <div className="form-check form-switch">
                    <label className="form-check-label" for="showRemark">
                      Show Remark
                    </label>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="showRemark"
                      name="showRemark"
                      defaultChecked={formik.values.showRemark}
                      {...formik.getFieldProps("showRemark")}
                    />
                  </div>
                </div>
              </div>

              <div className={editClasses.rightContainer}>
                <div className={editClasses.QrContainer}>
                  {!formik.values.standy ? (
                    <button
                      className="btn btn-primary mb-2"
                      type="button"
                      disabled={loadingQR}
                      onClick={() => {
                        generateQrCode();
                      }}
                    >
                      {loadingQR && (
                        <div
                          className="spinner-border spinner-border-sm mr-1"
                          role="status"
                        >
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      )}
                      Generate QR Code
                    </button>
                  ) : (
                    <>
                      {loadingQR ? (
                        <>
                          <div
                            className="spinner-border spinner-border-sm mr-1 loadQr"
                            role="status"
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        </>
                      ) : (
                        <div className={editClasses.codeDiv}>
                          <div>
                            <img
                              style={{ height: "100%", width: "100%" }}
                              src={formik.values.standy}
                            />
                            <img
                              className={editClasses.editLogo}
                              src={require("../../../../assets/img/admin-images/edit.png")}
                              onClick={() => generateQrCode()}
                            />
                            <img
                              className={editClasses.downloadIcon}
                              onClick={() => {
                                donwloadQrCode(formik.values.standy);
                              }}
                              src={require("../../../../assets/img/admin-images/download.png")}
                            />
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>

            <hr className={classes.hr1} />
            <div>
              <h3>Edit Covid Questions</h3>
              <div>
                <input
                  className={`${classes.footerInpDiv} ${classes.covidQue}`}
                  placeholder="Q1. Add Title"
                  id="que1"
                  name="que1"
                  {...formik.getFieldProps("que1")}
                />
                <textarea
                  className={`${classes.footerInpDiv} ${classes.covidQue}`}
                  placeholder="Answer"
                  id="ans1"
                  name="ans1"
                  {...formik.getFieldProps("ans1")}
                />
                <span className={formclasses.profileerrMsg}>
                  {formik.touched.ans1 && formik.errors.ans1 ? (
                    <div>{formik.errors.ans1}</div>
                  ) : null}
                </span>
              </div>
              <hr className={classes.hr1} style={{ width: "80%" }} />

              <div>
                <input
                  className={`${classes.footerInpDiv} ${classes.covidQue}`}
                  placeholder="Q2. Add Title"
                  id="que2"
                  name="que2"
                  {...formik.getFieldProps("que2")}
                />
                <textarea
                  className={`${classes.footerInpDiv} ${classes.covidQue}`}
                  placeholder="Answer"
                  id="ans2"
                  name="ans2"
                  {...formik.getFieldProps("ans2")}
                />
              </div>
              <hr className={classes.hr1} style={{ width: "80%" }} />

              <div>
                <input
                  className={`${classes.footerInpDiv} ${classes.covidQue}`}
                  placeholder="Q3. Add Title"
                  id="que3"
                  name="que3"
                  {...formik.getFieldProps("que3")}
                />
                <textarea
                  className={`${classes.footerInpDiv} ${classes.covidQue}`}
                  placeholder="Answer"
                  id="ans3"
                  name="ans3"
                  {...formik.getFieldProps("ans3")}
                />
              </div>
              <hr className={classes.hr1} style={{ width: "80%" }} />

              <div>
                <input
                  className={`${classes.footerInpDiv} ${classes.covidQue}`}
                  placeholder="Q4. Add Title"
                  id="que4"
                  name="que4"
                  {...formik.getFieldProps("que4")}
                />
                <textarea
                  className={`${classes.footerInpDiv} ${classes.covidQue}`}
                  placeholder="Answer"
                  id="ans4"
                  name="ans4"
                  {...formik.getFieldProps("ans4")}
                />
              </div>
              <hr className={classes.hr1} style={{ width: "80%" }} />

              <div>
                <input
                  className={`${classes.footerInpDiv} ${classes.covidQue}`}
                  placeholder="Q5. Add Title"
                  id="que5"
                  name="que5"
                  {...formik.getFieldProps("que5")}
                />
                <textarea
                  className={`${classes.footerInpDiv} ${classes.covidQue}`}
                  placeholder="Answer"
                  id="ans5"
                  name="ans5"
                  {...formik.getFieldProps("ans5")}
                />
              </div>
            </div>
            <div className={formclasses.formBtn}>
              {/* <button className={formclasses.cancleBtn}>Cancle</button> */}
              <button
                type="submit"
                disabled={loading}
                className={formclasses.createBtn}
              >
                {loading && (
                  <div
                    className="spinner-border spinner-border-sm mr-1"
                    role="status"
                  >
                    <span className="visually-hidden">Loading...</span>
                  </div>
                )}
                Update
              </button>
            </div>
          </form>
        </div>
      </div>
      <Modal
        isOpen={showDeleteModal}
        onRequestClose={handleDeleteCancel}
        contentLabel="Delete Manager Confirmation"
        style={{
          content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            maxWidth: '400px',
            width: '90%',
            padding: '20px',
            borderRadius: '8px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
          },
          overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.5)'
          }
        }}
      >
        <h2 style={{ marginTop: 0 }}>Delete Manager</h2>
        <p>Are you sure you want to delete this manager?</p>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '20px' }}>
          <button
            onClick={handleDeleteCancel}
            style={{
              padding: '8px 16px',
              border: '1px solid #ccc',
              borderRadius: '4px',
              background: 'white',
              cursor: 'pointer'
            }}
          >
            Cancel
          </button>
          <button
            onClick={handleDeleteConfirm}
            style={{
              padding: '8px 16px',
              border: '1px solid #dc3545',
              borderRadius: '4px',
              background: '#dc3545',
              color: 'white',
              cursor: 'pointer'
            }}
          >
            Delete
          </button>
        </div>
      </Modal>
    </>
  );
};

export default EditNewCompany;
